import { apolloClient } from '@/vue-apollo'
import gql from 'graphql-tag'
import { defineStore } from 'pinia'

export const useFavoriteStore = defineStore('favoriteStore', {
  state: ()=> ({
    isLoading: false,
    error: null,
    favoriteProduct: <any>null,
    favorite: <any>null,
    favorites: <any>[],
    favoriteBrand: <any>null,
    favoriteEvent: <any>null,
    favoriteRoutine: <any>null,
  }),
  actions: {
    async axFavorites(userId: string, query="") {
      this.isLoading = true;
      try {
        const response = await apolloClient.query({
          variables: {
            userId,
            query
          },
          query: gql`
            query userFavorites($userId: String!, $query: String) {
                userFavorites(userId: $userId, query: $query) {
                id
                type
                product {
                  id
                  title
                  url
                  rating
                  description
                  category {
                      title 
                  }
                  reviews {
                    rating
                  }
                }
                brand {
                  id
                  name
                  logo
                  reviews {
                    rating
                  }
                }
                event {
                  id
                  title
                  logo
                  onDate
                }
                routine {
                  id
                  title
                  banner
                  createdBy {
                    profile {
                      nickName
                    }
                  }
                }
              }
            }
          `,
          fetchPolicy: 'network-only',
        })
  
        if (response.data.userFavorites) {
          this.favorites = response.data.userFavorites;
          this.isLoading = false;
          return true
        } else {
          this.favorites = [];
          this.isLoading = false;
          return false
        }
        
      } catch (error) {
        this.isLoading = false;
        this.favorites = [];
      }
    },

    async axFavorite(data: any) {
        this.isLoading = true;
        try {
            const response = await apolloClient.query({
              variables: {
                data,
              },
              query: gql`
                query userFavoriteByData($data: UserFavoriteInput) {
                    userFavoriteByData(data: $data) {
                    id
                    type
                    user {
                        id
                    }
                  }
                }
              `,
              fetchPolicy: 'network-only',
            })
      
            if (response.data.userFavoriteByData?.id) {
              this.favorite = response.data.userFavoriteByData;
              this.isLoading = false;
              return true
            } else {
              this.favorite = null;
              this.isLoading = false;
              return false
            }
        } catch (error) {
            this.favorite = null;
            this.isLoading = false;
        }
    },
    
    async axFavoriteProduct(id: any) {
        this.isLoading = true;
        const response = await apolloClient.query({
          variables: {
            id,
          },
          query: gql`
            query brand($id: String!) {
              brand(id: $id) {
                id
                logo
                website
                name
                description
                products {
                  id
                  url
                  title
                  rating
                  description
                  category {
                    title
                  }
                  reviews {
                    id
                    title
                    description
                    rating
                  }
                }
                reviews {
                  id
                  title
                  description
                  rating
                }
              }
            }
          `,
          fetchPolicy: 'network-only',
        })
  
        if (response.data.brand) {
          this.favoriteProduct = response.data.brand;
          this.isLoading = false;
          return true
        } else {
          this.favoriteProduct = null;
          this.isLoading = false;
          return false
        }
    },

    async axCreateFavorite(data: any) {
        this.isLoading = true;
        try {
            const response = await apolloClient.mutate({
              variables: {
                data,
              },
              mutation: gql`
                mutation createUserFavorite($data: UserFavoriteInput) {
                    createUserFavorite(data: $data) {
                    id
                  }
                }
              `,
              fetchPolicy: 'network-only',
            })
      
            if (response.data.createUserFavorite.id) {
              this.isLoading = false;
              return true
            } else {
              this.isLoading = false;
              return false
            }
          } catch (error) {
            this.isLoading = false;
            return false;
          }
    },

    async axDeleteFavorite(id: any) {
        this.isLoading = true;
        try {
            const response = await apolloClient.mutate({
              variables: {
                id,
              },
              mutation: gql`
                mutation deleteUserFavorite($id: String!) {
                    deleteUserFavorite(id: $id)
                }
              `,
              fetchPolicy: 'network-only',
            })

            if (response.data.deleteUserFavorite === "success") {
              this.isLoading = false;
              return true
            } else {
              this.isLoading = false;
              return false
            }
          } catch (error) {
            this.isLoading = false;
            return false;
          }
    }
  },

  getters: {
    getFavorites: (state: any) => {
        const favoriteProducts = state.favorites.filter((item: any) => item.type === "product");
        const favoriteBrands = state.favorites.filter((item: any) => item.type === "brand");
        const favoriteEvents = state.favorites.filter((item: any) => item.type === "event");
        const favoriteRoutines = state.favorites.filter((item: any) => item.type === "routine");
        const data = {
            favoriteProducts,
            favoriteBrands,
            favoriteEvents,
            favoriteRoutines
        }
        return data;
    }
  }

})